import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities'

class ReferalProgramRepository {

    constructor(){
        this.basePath = store.state.backend;
    }
    getReferrer(refId){
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/referrer-exist/${refId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

}
export default new ReferalProgramRepository();